module.exports = __webpack_public_path__ + "assets/5f6e9dd62f6925779a5336f951c46424.mp3";